<template>
  <div>
    <ListRecipesComponent/>
  </div>
</template>

<script>
import ListRecipesComponent from '@/components/ListRecipesComponent.vue';

export default {
  name: 'HomeView',
  components: {
    ListRecipesComponent
  }
}
</script>
